import React from "react";
import { TextInput, required, ReferenceInput, SelectInput, BooleanInput, NumberInput } from "react-admin";
import { Grid } from "@mui/material";
import SecuredComponent from "server/security/SecuredComponent";
import { tenants } from "utils/tenants";
import { settings } from "app";
import { paymentRequests } from "api/paymentApi";
import { administrationRequests } from "api/administrationApi";

const SaveForm = () => {
  const validateMaxDisciplineFailures = value => {
    if (value < 0) {
      return "Стойността трябва да е положително число";
    }
    return undefined;
  };

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="directionId"
          reference={administrationRequests.getDirectionsSelect()}
          filter={{ filterByUser: true }}
        >
          <SelectInput
            validate={required()}
            optionText="name"
            label="Направление"
          />
        </ReferenceInput>
      </Grid>

      <SecuredComponent tenancies={tenants.MU}>
        <Grid
          item
          xs={12}
          md={6}
        >
          <ReferenceInput
            source="defaultIbanId"
            reference={paymentRequests.getIbansSelect()}
          >
            <SelectInput
              optionText="name"
              label="Iban"
            />
          </ReferenceInput>
        </Grid>
      </SecuredComponent>

      <Grid
        item
        xs={12}
        md={6}
      >
        <NumberInput
          source="maxDisciplineFailures"
          label="Брой скъсвания"
          validate={[required(), validateMaxDisciplineFailures]}
        />
      </Grid>
      {settings.tenant === tenants.MU && (
        <Grid
          item
          xs={12}
          md={6}
        >
          <BooleanInput
            label={"Предлага специална група?"}
            source={"hasSpecialGroup"}
            defaultValue={true}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default SaveForm;
